import React, { useState, useEffect, useRef } from 'react';
import styles from './styles.module.css';
import { Input, Toggle, Button } from '../../../../../../common/ui';
import ImageUpload from '../ImageUpload';

const initialVariant = {
  variantName: '',
  code: '',
  barcode: '',
  price: '',
  cost: '',
  availability: false,
  isSerialCheck: false,
  images: [],
};

const AddNewVariantPopup = ({
  isOpen,
  onClose,
  productType,
  onAddVariant,
}) => {
  const [form, setForm] = useState(initialVariant);
  const nameRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setForm(initialVariant);
      setTimeout(() => nameRef.current?.focus(), 0);
    }
  }, [isOpen]);

  const onFieldChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleReset = () => {
    setForm(initialVariant);
    setTimeout(() => nameRef.current?.focus(), 0);
  };

  const handleAdd = () => {
    const data = {
      variantName: (form.variantName ?? '').trim(),
      code: form.code ?? '',
      barcode: form.barcode ?? '',
      price: form.price ? parseFloat(form.price) : 0,
      cost: form.cost ? parseFloat(form.cost) : 0,
      availability: form.availability,
      isSerialCheck: form.isSerialCheck,
      images: form.images,
    };
    onAddVariant?.(data);
    setForm(initialVariant);
    onClose?.();
  };

  if (!isOpen) return null;

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-variant-title"
    >
      <div
        className={styles.panel}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.headerBar}>
          <h2 id="add-variant-title" className={styles.headerTitle}>
            Add New Product Variant
          </h2>
        </div>
        <div className={styles.content}>
          <div className={styles.formRow}>
            <div className={styles.fieldGroup}>
              <Input
                label="Variant Name"
                type="text"
                value={form.variantName ?? ''}
                onChange={(value) => onFieldChange('variantName', value)}
                placeholder="Enter variant name"
              />
            </div>
            <div className={styles.fieldGroup}>
              <Input
                label="Code"
                type="text"
                value={form.code ?? ''}
                onChange={(value) => onFieldChange('code', value)}
              />
            </div>
          </div>
          <div className={styles.formRow}>
            <div className={styles.fieldGroup}>
              <Input
                label="Barcode"
                type="text"
                value={form.barcode ?? ''}
                onChange={(value) => onFieldChange('barcode', value)}
              />
            </div>
            {productType === 'NON_STOCK' && (
              <>
                <div className={styles.fieldGroup}>
                  <Input
                    label="Price"
                    type="text"
                    value={form.price ?? ''}
                    onChange={(value) => onFieldChange('price', value)}
                    placeholder="0.00"
                  />
                </div>
                <div className={styles.fieldGroup}>
                  <Input
                    label="Cost"
                    type="text"
                    value={form.cost ?? ''}
                    onChange={(value) => onFieldChange('cost', value)}
                    placeholder="0.00"
                  />
                </div>
              </>
            )}
          </div>

          {productType === 'STOCK' && (
            <div className={styles.formRow}>
              <div className={styles.fieldGroup}>
                <Toggle
                  label="Serial Number Validation"
                  labelPlacement="start"
                  name="variantSerialCheck"
                  checked={form.isSerialCheck}
                  onChange={(e) => onFieldChange('isSerialCheck', e.target.checked)}
                />
              </div>
              <div className={styles.fieldGroup} />
            </div>
          )}

          {productType === 'NON_STOCK' && (
            <div className={styles.formRow}>
              <div className={styles.fieldGroup}>
                <Toggle
                  label="Availability"
                  labelPlacement="start"
                  name="variantAvailability"
                  checked={form.availability}
                  onChange={(e) => onFieldChange('availability', e.target.checked)}
                />
              </div>
              <div className={styles.fieldGroup} />
            </div>
          )}

          <div className={styles.imageDivider} />

          <ImageUpload
            images={form.images}
            onChange={(imgs) => onFieldChange('images', imgs)}
          />
        </div>

        <div className={styles.footerBar}>
          <Button type="button" onClick={handleAdd}>
            Add variant
          </Button>
          <Button type="button" variant="secondary" onClick={handleReset}>
            Reset
          </Button>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddNewVariantPopup;
